import React, { useContext, useEffect, useState } from 'react';
import { Badge, Stack } from '@mui/material';

import { AppContext, AppDispatchContext } from 'context/app';
import { useAspenLogger } from 'hooks/useAspenLogger';

import { NavActionButton } from 'layout/navigation/navActions/NavActionButton';

const getBadgeContent = (eventsFilterCount: string | null) => (eventsFilterCount ? parseInt(eventsFilterCount, 10) : 0);

export const EventsNav = (): React.ReactNode => {
  const { eventsFilterOpen } = useContext(AppContext);
  const dispatch = useContext(AppDispatchContext);
  const { logAspenEvent } = useAspenLogger();

  const [badgeContent, setBadgeContent] = useState<number>(
    getBadgeContent(sessionStorage.getItem('eventsFilterCount')),
  );

  useEffect(
    () => () => {
      dispatch({
        type: 'eventsFilterOpen',
        payload: false,
      });
    },
    [],
  );

  // Initialize badge content from session storage on mount
  useEffect(() => {
    setBadgeContent(getBadgeContent(sessionStorage.getItem('eventsFilterCount')));
  }, []);

  // Listen for filter count changes
  useEffect(() => {
    const handleFilterCountChange = (event: CustomEvent) => {
      setBadgeContent(event.detail.filterCount);
    };

    window.addEventListener('eventsFilterCountChanged', handleFilterCountChange as EventListener);

    return () => {
      window.removeEventListener('eventsFilterCountChanged', handleFilterCountChange as EventListener);
    };
  }, []);

  return (
    <Stack direction="row" spacing={2}>
      <Badge
        data-testid="badge-events-filter"
        badgeContent={badgeContent}
        color="primary"
        invisible={!badgeContent}
        sx={{
          '& .MuiBadge-badge': {
            display: 'flex',
            alignContent: 'center',
            right: '-3px',
            justifyContent: 'center',
            height: 'auto',
            borderRadius: '8px',
            border: '2px solid #fff',
            fontWeight: 'normal',
            lineHeight: 'inherit',
          },
        }}
      >
        <NavActionButton
          className="active"
          data-testid="nav-action-button-filter"
          onClick={() => {
            logAspenEvent({
              log_id: 'iot.web.event.action',
              payload: {
                action: eventsFilterOpen ? 'filter_close' : 'filter_open',
              },
            });

            dispatch({
              type: 'eventsFilterOpen',
              payload: !eventsFilterOpen,
            });
          }}
        >
          Filters
        </NavActionButton>
      </Badge>
    </Stack>
  );
};
